import axios from 'axios';
import downloadv2 from '@/api/downloadv2.service';
import { IS_PRODUCTION } from '../config';

export default async function downloadVideo({ video, captions, stinger }) {
  if (video.subtitles.ref && !video.subtitles.finishedAt) {
    const urlToFetch = IS_PRODUCTION
      ? 'https://er1hwnipfb.execute-api.us-east-1.amazonaws.com/default/wavve-downloader-dev-videoDownloader'
      : 'https://tuz5rp5u61.execute-api.us-east-1.amazonaws.com/default/wavve-downloader-videoDownloader';

    axios
      .post(
        urlToFetch,
        {
          uuid: video.guid,
          subtitles: captions,
          title: video.title,
          stinger,
        },
        { 'Content-Type': 'application/json', withCredentials: false }
      )
      .then(response => {
        const link = document.createElement('a');
        link.href = response.url;
        link.click();
        URL.revokeObjectURL(link.href);
      })
      .catch(console.error);

    return;
  }

  const { url } = await downloadv2.downloadJob({ name: video.title, guid: video.guid, captions });

  const link = document.createElement('a');

  link.href = url;

  link.target = '_blank';

  link.click();

  URL.revokeObjectURL(link.href);

  return;
}
